import request from '@/utils/request'

//获取到验证码数据
export function getVcode(params) {
  return request({
    url: '/sys/verifyCode',
    method: 'get',
    params: params,
    responseType: 'blob'
  })
}

//登录接口
export function goLogin(data) {
  return request({
    url: '/sys/login',
    method: 'post',
    data,
    headers: {
        'Content-Type': 'application/json'
    },
  })
}

//获取到当前用户的权限信息
export function getProfile(data) {
  return request({
    url: '/sys/profile',
    method: 'post',
    data
  })
}


//获取当前登录人信息，角色，权限等
export function userInfo() {
  return request({
    url: '/sys/userInfo',
    method: 'get',
  })
}


/****
 * 用户操作
 * */

//获取到用户数据信息
export function getUserPageList(data) {
  return request({
    url: '/sys/admin/findByPage',
    method: 'post',
    data,
    // headers: {
    //     'Content-Type': 'application/json'
    // },
  })
}

//添加角色信息
export function addUser(data) {
  return request({
    url: '/sys/admin/add',
    method: 'post',
    data,
  })
}

//获取用户详情信息   根据角色Id
export function getUserInfo(params) {
  return request({
    url: '/sys/admin/getById/'+params,
    method: 'get',
  })
}

//获取用户详情信息   根据登录人的Id
export function getUserInfoByLoginId() {
  return request({
    url: '/sys/admin/getByLoginId',
    method: 'get',
  })
}



//修改用户信息
export function userModify(data) {
  return request({
    url: '/sys/admin/modify',
    method: 'post',
    data,
  })
}

//将用户删除
export function delUser(data) {
  return request({
    url: '/sys/admin/del',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    },
  })
}

//将角色删除
export function getAllRoles() {
  return request({
    url: '/sys/admin/getAllRoles',
    method: 'get',
  })
}


//根据用户id获取到该用户的所有角色id
export function getUserInfoForRoles(params) {
  return request({
    url: '/sys/admin/getUserInfoForRoles/'+params,
    method: 'get',
  })
}

//将角色删除
export function assignRoles(data) {
  return request({
    url: '/sys/admin/assignRoles',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    },
  })
}


/****
 * 角色操作
 * */
//获取到角色数据信息
export function getRolePageList(data) {
  return request({
    url: '/sys/role/findByPage',
    method: 'post',
    data,
    // headers: {
    //     'Content-Type': 'application/json'
    // },
  })
}

//获取角色详情信息   根据角色Id
export function getRoleInfo(params) {
  return request({
    url: '/sys/role/'+params,
    method: 'get',
  })
}

//添加角色信息
export function addRole(data) {
  return request({
    url: '/sys/role/add',
    method: 'post',
    data,
  })
}

//修改角色信息
export function roleModify(data) {
  return request({
    url: '/sys/role/modify',
    method: 'post',
    data,
  })
}

//按照菜单分类获取到所有的权限信息
export function getAuthByMenu(params) {
  return request({
    url: '/sys/role/getPermissionByMenu/'+params,
    method: 'get',
    params: params,
  })
}

//将分配给指定角色的权限保存
export function assignRoleAuth(data) {
  return request({
    url: '/sys/role/assignPrem/',
    method: 'post',
    data,
    headers: {
        'Content-Type': 'application/json'
    },
  })
}


//将角色删除
export function delRole(data) {
  return request({
    url: '/sys/role/del',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    },
  })
}



/****
 * 权限操作
 * */
//获取到权限数据信息
export function getPermissionPageList(data) {
  return request({
    url: '/sys/permission/findAll',
    method: 'post',
    data,
    headers: {
        'Content-Type': 'application/json'
    },
  })
}

//新增权限
export function addPermission(data) {
  return request({
    url: '/sys/permission/add',
    method: 'post',
    data,
    headers: {
        'Content-Type': 'application/json'
    },
  })
}


//获取权限详情信息
export function getPermissionInfo(params) {
  return request({
    url: '/sys/permission/'+params,
    method: 'get',
    params: params,
  })
}

//修改权限信息
export function editPermissionInfo(data) {
  return request({
    url: '/sys/permission/edit',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    },
  })
}

//获取到权限(菜单)列表数据
export function getPermissionMenuList() {
  return request({
    url: '/sys/getPermissionMenuList',
    method: 'get',
  })
}


//删除权限(菜单)列表(一个或者多个)
export function delPermissionIds(data) {
  return request({
    url: '/sys/permission/delete',
    method: 'post',
    data
  })
}


//获取到权限(菜单)列表数据   --  用于侧边栏展示
export function getPermissionMenuListForTabBar() {
  return request({
    url: '/sys/getPermissionMenuListForTabBar',
    method: 'get',
  })
}





/****
 * 字典操作
 * */

//获取到字典数据信息
export function getDictPageList(data) {
  return request({
    url: '/sys/dict/findByPage',
    method: 'post',
    data,
  })
}

//获取到字典数据信息提供给选择父ID使用
export function findAllForSelect(data) {
  return request({
    url: '/sys/dict/findAllForSelect',
    method: 'post',
    data,
  })
}

//添加字典信息
export function addDict(data) {
  return request({
    url: '/sys/dict/add',
    method: 'post',
    data,
  })
}

//获取字典详情信息
export function getDictInfo(params) {
  return request({
    url: '/sys/dict/getById/'+params,
    method: 'get',
  })
}

//修改用户信息
export function dictModify(data) {
  return request({
    url: '/sys/dict/modify',
    method: 'post',
    data,
  })
}

//将字典删除
export function delDict(data) {
  return request({
    url: '/sys/dict/del',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    },
  })
}

//下载字典模板
export function downloadTemp() {
  return request({
    url: '/sys/dict/downloadTemp',
    method: 'get',
    responseType: "blob"
  })
}

//下载字典数据
export function downloadExcel() {
  return request({
    url: '/sys/dict/downloadExcel',
    method: 'get',
    responseType: "blob"
  })
}


// 导入引进总分分数文件
export function importExcelDict(data) {
  return request({
      url: '/sys/dict/importDict',
      method: 'post',
      data
  })
}


//大屏数据信息
export function screenAllCount(params) {
  return request({
      url: '/screen/allCount',
      method: 'get',
      params
  })
}


